import {
  priceCeilingIsConstrained,
  priceFloorIsConstrained,
  stripRedundantPriceParamsFromCurrentLocation,
} from "./price-filter-url.js";
import { c as y } from "./focus-trap.esm.CPw4bcQR.min.js";
import { E as n } from "./events.Dnaewmpi.min.js";
import { d as E, e as v } from "./body-scroll.DgdyyK_9.min.js";
import { S as w } from "./sections-api-service.smvSsykG.min.js";
import { p as k } from "./parse-html.C-hh7jJd.min.js";

class g extends HTMLElement {
  constructor() {
    (super(),
      (this.active = this.getAttribute("data-active") === "true"),
      (this.openTriggers = document.querySelectorAll(
        "[data-filter-drawer-trigger]",
      )),
      (this.closeTriggers = this.querySelectorAll("[data-close]")),
      (this.content = this.querySelector("[data-content]")),
      (this.applyButton = this.querySelector("[data-filter-apply]")),
      (this.inputs = this.querySelectorAll("input")),
      (this.applyButtonCountEl = this.applyButton.querySelector(
        "[data-product-count]",
      )),
      (this.productCountWrapper = document.querySelector(
        "[data-product-count-wrapper]",
      )),
      (this.trap = y(this, { allowOutsideClick: !0 })));
  }
  connectedCallback() {
    (this.openTriggers.forEach((e) =>
      e.addEventListener("click", this.open.bind(this)),
    ),
      this.closeTriggers.forEach((e) =>
        e.addEventListener("click", this.close.bind(this)),
      ),
      this.addEventListener("change", this.handleInputChange.bind(this)),
      document.addEventListener("keydown", (e) => this.keyDown(e)),
      document.addEventListener(n.FILTER_UPDATE, this.render.bind(this)),
      this.applyButton.addEventListener("click", this.close.bind(this)));
  }
  disconnectedCallback() {
    (this.openTriggers.forEach((e) =>
      e.removeEventListener("click", this.open.bind(this)),
    ),
      this.closeTriggers.forEach((e) =>
        e.removeEventListener("click", this.close.bind(this)),
      ),
      this.removeEventListener("change", this.handleInputChange.bind(this)),
      document.removeEventListener("keydown", (e) => this.keyDown(e)),
      document.removeEventListener(n.FILTER_UPDATE, this.render.bind(this)),
      this.applyButton.removeEventListener("click", this.close.bind(this)));
  }
  keyDown({ key: e }) {
    e && (e === "Escape" || e === "Esc") && this.close();
  }
  open() {
    ((this.active = !0),
      (this.style.display = "block"),
      setTimeout(() => {
        (this.setAttribute("data-active", !0),
          this.setAttribute("aria-hidden", !1),
          this.setAttribute("aria-modal", !0),
          this.openTriggers.forEach((e) => e.setAttribute("aria-expanded", !0)),
          E(),
          setTimeout(this.trap.activate, 100));
      }, 10));
  }
  close() {
    ((this.active = !1),
      this.trap.deactivate(),
      this.setAttribute("data-active", !1),
      this.setAttribute("aria-hidden", !0),
      this.setAttribute("aria-modal", !1),
      this.openTriggers.forEach((e) => e.setAttribute("aria-expanded", !1)),
      v(),
      setTimeout(() => (this.style.display = "none"), 200));
  }
  handleInputChange(e) {
    this.apply(!1, e.target);
  }
  apply(s = !0, changedInput = null) {
    const shouldAutoApplyAvailability =
      changedInput instanceof HTMLInputElement &&
      changedInput.type === "checkbox" &&
      changedInput.name.includes("size") &&
      changedInput.checked;
    const e = this.getBaseUrlWithPreservedParams(["q"]);
    (this.inputs.forEach((s) => {
        const r = s.name,
          i = s.value,
          o = s.getAttribute("max");
        (s.type === "checkbox" && s.checked && e.searchParams.append(r, i),
          s.type === "radio" && s.checked && e.searchParams.append(r, i),
          s.type === "number" &&
            ((s.hasAttribute("data-min-input") &&
              priceFloorIsConstrained(i, s.getAttribute("min"))) ||
              (s.hasAttribute("data-max-input") &&
                priceCeilingIsConstrained(i, o))) &&
            e.searchParams.set(r, i));
      }),
      shouldAutoApplyAvailability &&
        (e.searchParams.delete("filter.v.availability"),
        e.searchParams.append("filter.v.availability", "1")),
      window.history.replaceState(null, "", e),
        s && this.close(),
      document.dispatchEvent(new CustomEvent(n.FILTER_UPDATE)));
  }
  async render() {
    const e = new URL(window.location.href),
      fetchedUrl = e.toString(),
      s = await w.fetch(e, "main-product-grid");
    if (window.location.href !== fetchedUrl) return;
    const r = k(s),
      i = r.querySelectorAll("filter-drawer input"),
      o = r.querySelector("[data-product-count]"),
      d = r.querySelector("[data-product-count-wrapper]"),
      h = r.querySelector("#filterCount").value,
      u = document.querySelector("#filterCountData");
    if (
      (h == "0" ? (u.innerText = "") : (u.innerText = `(${h})`),
      this.productCountWrapper)
    ) {
      const t = d == null ? void 0 : d.classList.contains("hidden");
      this.productCountWrapper.classList.toggle("hidden", t);
    }
    ((this.applyButtonCountEl.innerText =
      (o == null ? void 0 : o.innerText) || 0),
      this.inputs.forEach((t) => {
        var m, b;
        const p =
            (m = t.parentElement) == null
              ? void 0
              : m.querySelector("[data-count]"),
          a = Array.from(i).find((c) => c.id === t.id),
          f =
            (b = a == null ? void 0 : a.parentElement) == null
              ? void 0
              : b.querySelector("[data-count]");
        if (
          (t.name.includes("size") &&
            (t
              .closest(".checkbox-wrapper__size")
              .removeAttribute("data-checked"),
            t
              .closest(".checkbox-wrapper__size")
              .removeAttribute("data-disabled")),
          !!a)
        ) {
          if ((p && (p.innerText = f.innerText), t.name.includes("sort"))) {
            const c = t.closest("radio-button"),
              l = a.closest("radio-button");
            (c.removeAttribute("data-checked"),
              l.hasAttribute("data-checked") &&
                c.setAttribute("data-checked", ""));
          }
          if (
            ((t.checked = a.checked),
            (t.disabled = a.disabled),
            (t.type === "number" || t.type === "range") && (t.value = a.value),
            t.name.includes("size"))
          ) {
            const c = a
                .closest(".checkbox-wrapper__size")
                .hasAttribute("data-checked"),
              l = a
                .closest(".checkbox-wrapper__size")
                .hasAttribute("data-disabled");
            (c &&
              t
                .closest(".checkbox-wrapper__size")
                .setAttribute("data-checked", ""),
              l &&
                t
                  .closest(".checkbox-wrapper__size")
                  .setAttribute("data-disabled", ""));
          }
        }
      }));
    stripRedundantPriceParamsFromCurrentLocation();
  }
  getBaseUrlWithPreservedParams(e = []) {
    const s = new URL(window.location.href),
      r = new URL(`${window.location.origin}${window.location.pathname}`);
    return (
      e.forEach((i) => {
        const o = s.searchParams.get(i);
        o !== null && r.searchParams.set(i, o);
      }),
      r
    );
  }
}
const q = () => {
  customElements.get("filter-drawer") ||
    customElements.define("filter-drawer", g);
};
q();
export { q as default };
